import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { ShortlinkComponent } from './shortlink.component';

@NgModule({
  declarations: [ShortlinkComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  exports: [ShortlinkComponent]
})
export class ShortlinkModule {}
